import styled from 'styled-components';

import { colorBlack700 } from '@/styleUtils';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  min-height: 18px;
`;

export const Content = styled.div`
  position: relative;
  width: ${({ $width }) => `${$width}px`};
  height: ${({ $height }) => `${$height}px`};
`;

export const Star = styled.div`
  position: ${({ $position }) => $position || 'absolute'};
  top: 0;
  left: 0;
  width: ${({ $width }) => `${$width}px`};
  height: ${({ $height }) => `${$height}px`};
  background-color: ${({ $color }) => $color};
  mask-image: ${({ $background }) => `url('${$background}')`};
  mask-position: 0 50%;
  mask-repeat: repeat no-repeat;
  mask-size: ${({ $size, $height }) => `${$height}px ${$size}px`};
  pointer-events: none;
`;
export const RatingValue = styled.span`
  margin-top: 2px;
  font-size: 12px;
  line-height: 16px;
  color: ${colorBlack700};
`;
